import { PhaseManager } from './PhaseManager';
import { CorePhases } from '../types';
import { modes, CustomEvents } from '@powerplay/common';
export class PhaseInstructionsManager extends PhaseManager {
    cameraManager;
    inputsManager;
    fpsManager;
    requestManager;
    isEnabled = false;
    firstInstructions = false;
    constructor(firstInstructions, cameraManager, inputsManager, fpsManager, requestManager) {
        super(cameraManager, inputsManager, fpsManager, requestManager);
        this.cameraManager = cameraManager;
        this.inputsManager = inputsManager;
        this.fpsManager = fpsManager;
        this.requestManager = requestManager;
        this.firstInstructions = firstInstructions;
        this.PHASE_NAME = 'INSTRUCTIONS';
        this.skippable = false;
        this.phaseNumber = CorePhases.instructions;
        this.TIME_TO_NEXT_PHASE = 0;
    }
    setIsEnabled = () => {
        if (modes.isTutorial()) {
            this.isEnabled = false;
            return;
        }
        if (!modes.isAppWSM2021()) {
            this.isEnabled = this.firstInstructions;
            return;
        }
        const index = `firstInstructionsWSM2021-${this.requestManager.disciplineID}`;
        const firstInstructions = window.localStorage.getItem(index);
        if (!firstInstructions) {
            this.isEnabled = true;
            window.localStorage.setItem(index, '1');
        }
    };
    startPhase() {
        this.setIsEnabled();
        super.startPhase();
        if (!this.isEnabled) {
            this.finishPhase();
            return;
        }
        window.dispatchEvent(new CustomEvent(CustomEvents.startInstructionsPhase));
    }
}
//# sourceMappingURL=PhaseInstructionsManager.js.map